<template>
  <v-card>
    <v-card-title primary-title style="margin: 0;padding: 0;">
      <v-subheader>图表配置</v-subheader>
    </v-card-title>
    <v-container grid-list-md fluid ma-0 pa-0 pl-3 pr-3>
      <v-layout row wrap>
        <v-flex xs3>
          <v-autocomplete v-model="chart.type" :items="types" label="类型" hint="type">
          </v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete v-model="chart.zoomType" :items="['x','y','xy']" label="缩放" hint="zoomType">
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  import {
    Chart
  } from "./options.ts";
  export default Chart;
</script>